import { useEffect, useState } from 'react'

import { APP_VERSION } from '@/config.ts'
import { getAppVersion } from '@/repositories/appRepository.ts'
import { ONE_HOUR } from '@/utils/date.ts'
import { checkVersionIsBehind } from '@/utils/version.ts'

export const useVersionChecker = () => {
  const [targetVersion, setTargetVersion] = useState(APP_VERSION)
  const [isBehind, setIsBehind] = useState(false)

  useEffect(() => {
    const fetchVersionAndCheck = async () => {
      try {
        const latestVersion = await getAppVersion()
        setTargetVersion(latestVersion)
        setIsBehind(checkVersionIsBehind(APP_VERSION, latestVersion))
      } catch (error) {
        setIsBehind(false)
      }
    }

    fetchVersionAndCheck()
    const timer = setInterval(fetchVersionAndCheck, ONE_HOUR)
    return () => clearInterval(timer)
  }, [])

  return isBehind
    ? {
        id: 'update-notification',
        type: 'SYSTEM',
        title: 'Update Available',
        message: `A new version (${targetVersion}) of the app is available. Please update to the latest version by refreshing this page.`,
      }
    : null
}
